import 'driver.js/dist/driver.css';
import './assets/novelty-search-onboarding.scss';
import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { NoveltySearchOnboardingService } from './novelty-search-onboarding-service';
import { NoveltySearchOnboardingServiceImpl } from './impls/novelty-search-onboarding-service';
import { NoveltySearchOnboardingRuntime } from './novelty-search-onboarding-runtime';
import { NoveltySearchOnboardingRuntimeImpl } from './impls/novelty-search-onboarding-runtime';
import { NoveltySearchReportValueOnboardingService } from './novelty-search-report-value-onboarding-service';
import { NoveltySearchReportValueOnboardingServiceImpl } from './impls/novelty-search-report-value-onboarding-service';

/** 注册查新用户首次引导相关服务。 */
export const noveltySearchOnboardingModule = (bind: interfaces.Bind) => {
    bind(NoveltySearchOnboardingRuntime).to(NoveltySearchOnboardingRuntimeImpl);
    bind(NoveltySearchOnboardingService).to(NoveltySearchOnboardingServiceImpl).inTransientScope();
    bind(NoveltySearchReportValueOnboardingService).to(NoveltySearchReportValueOnboardingServiceImpl).inSingletonScope();
};

export { NoveltySearchOnboardingService } from './novelty-search-onboarding-service';
export { NoveltySearchOnboardingServiceImpl } from './impls/novelty-search-onboarding-service';
export { NoveltySearchReportValueOnboardingService } from './novelty-search-report-value-onboarding-service';
export { NoveltySearchReportValueOnboardingServiceImpl } from './impls/novelty-search-report-value-onboarding-service';
export { registerNoveltySearchReportOnboardingDebug } from './novelty-search-report-onboarding-debug';
export type {
    NoveltySearchOnboardingStartOptions,
} from './novelty-search-onboarding-service';
export type {
    NoveltySearchReportOnboardingDebugApi,
} from './novelty-search-report-onboarding-debug';
